import React from 'react';
import {Grid} from '@material-ui/core';
import {MDBPopover, MDBPopoverBody} from "mdbreact";
import {FastField} from "formik";
import AutoCompletePlacesSelectorContainer
  from 'data/redux/containers/autoCompletePlacesSelectorContainer/AutoCompletePlacesSelectorContainer';
import PlaceSelectorDetails from "./components/placeSelectorDetails";

export interface IPlaceSelectorProps {
  placeKey?: string;
  imagesPickKey?: string;
  label?: string;
  description?: string;
  disableImagePicker?: boolean;
}

const PlaceSelector = (props: IPlaceSelectorProps) => {
  return (<>
    <Grid item xs={12} style={{paddingBottom: 0}}>
      <MDBPopover
        placement="top"
        popover
        clickable
        domElement={true}
      >
        <div>
          <FastField
            component={AutoCompletePlacesSelectorContainer}
            label={props.label}
            name={props.placeKey}
          />
        </div>
        <div>
          <MDBPopoverBody>
            {props.description}
          </MDBPopoverBody>
        </div>
      </MDBPopover>
    </Grid>
    {!props.disableImagePicker ? <FastField
      component={PlaceSelectorDetails}
      placeKey={props.placeKey}
      imagesPickKey={props.imagesPickKey}
    /> : null}

  </>);
};

PlaceSelector.defaultProps = {
  label: 'כתובת',
  description: 'בחר כתובת',
  placeKey: 'place',
};

export default React.memo(PlaceSelector);
